export default __webpack_public_path__ + "static/media/java.aa3e0c9e.svg";